import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Panel from 'react-bootstrap/lib/Panel'

import Loading from 'components/Loading'
import FormModal from 'components/FormModal'
import ConfirmDialog from 'components/ConfirmDialog'

import AssignedCourses from './assigned-courses'
import FormAssignCourse from './form-assign-course'
import { fetchAssignedCourses, assignCourse, deleteAssignedCourse } from './actions'

class SetupCourses extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openForm: false,
      openConfirm: false,
      item: null,
    }
  }

  _showForm = () => {
    this.setState({
      openForm: true,
      item: null,
    })
  }

  _closeForm = () => {
    this.setState({
      openForm: false,
    })
  }

  _onSelectItem = (course) => {
    this.setState({
      openForm: true,
      item: course,
    })
  }

  _onDelete = () => {
    this.setState({
      openConfirm: true,
    })
  }

  _onSubmit = (input) => {
    this.props.dispatch(assignCourse(input))
    .then((res) => {
      if (!res.error) {
        this._closeForm()
      }
    })
  }

  _onConfirmDelete = () => {
    this.props.dispatch(deleteAssignedCourse(this.state.item.get('id')))
    .then((res) => {
      if (!res.error) {
        this._closeForm()
      }
      this.setState({
        openConfirm: false,
      })
    })
  }

  _renderConfirmDialog() {
    const { openConfirm } = this.state

    if (!openConfirm) {
      return null
    }

    return (
      <ConfirmDialog
        closeDialog={() => this.setState({ openConfirm: false })}
        confirmAction={this._onConfirmDelete}
      />
    )
  }

  _renderForm() {
    const { openForm, item } = this.state
    const { __pending } = this.props

    if (!openForm) {
      return null
    }

    return (
      <FormModal handleClose={this._closeForm}>
        <FormAssignCourse
          item={item}
          pending={__pending}
          onDelete={this._onDelete}
          onSubmit={this._onSubmit}
        />
      </FormModal>
    )
  }

  render() {
    const { __hasFetched, __list } = this.props

    if (!__hasFetched) {
      return <Loading />
    }

    return (
      <Panel header="Assign Courses">
        <div className="m-b-20">
          <button onClick={this._showForm} className="btn btn-info">Assign New Course</button>
        </div>
        <AssignedCourses
          items={__list}
          onSelectItem={this._onSelectItem}
        />
        {this._renderForm()}
        {this._renderConfirmDialog()}
      </Panel>
    )
  }
}

SetupCourses.onEnter = (store) => () => store.dispatch(fetchAssignedCourses())

SetupCourses.propTypes = {
  __list: PropTypes.object, // list of courses assigned
  __hasFetched: PropTypes.bool,
  __pending: PropTypes.bool,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __list: state.semcampcourse.get('list'),
    __hasFetched: state.semcampcourse.get('hasFetched'),
    __pending: state.semcampcourse.get('pending'),
  }
}

export default connect(mapStateToProps)(SetupCourses)



// WEBPACK FOOTER //
// ./src/containers/Setup/Courses/index.js